class BadDebtSuspensionModel {
  constructor(badDebtSuspensionModel?: BadDebtSuspensionModel) {
    this.divisionId = badDebtSuspensionModel ? badDebtSuspensionModel.divisionId == undefined ? '' : badDebtSuspensionModel.divisionId : '';
    // this.startDate = badDebtSuspensionModel ? badDebtSuspensionModel.startDate == undefined ? '' : badDebtSuspensionModel.startDate : '';
    // this.endDate = badDebtSuspensionModel ? badDebtSuspensionModel.endDate == undefined ? '' : badDebtSuspensionModel.endDate : '';
    this.branchId = badDebtSuspensionModel ? badDebtSuspensionModel.branchId == undefined ? '' : badDebtSuspensionModel.branchId : '';
    this.isCurrent = badDebtSuspensionModel ? badDebtSuspensionModel.isCurrent == undefined ? false : badDebtSuspensionModel.isCurrent : false;
    this.is30Days = badDebtSuspensionModel ? badDebtSuspensionModel.is30Days == undefined ? false : badDebtSuspensionModel.is30Days : false;
    this.is60Days = badDebtSuspensionModel ? badDebtSuspensionModel.is60Days == undefined ? false : badDebtSuspensionModel.is60Days : false;
    this.is90Days = badDebtSuspensionModel ? badDebtSuspensionModel.is90Days == undefined ? false : badDebtSuspensionModel.is90Days : false;
    this.is120Days = badDebtSuspensionModel ? badDebtSuspensionModel.is120Days == undefined ? false : badDebtSuspensionModel.is120Days : false;
    this.is150Days = badDebtSuspensionModel ? badDebtSuspensionModel.is150Days == undefined ? false : badDebtSuspensionModel.is150Days : false;
    this.is180Days = badDebtSuspensionModel ? badDebtSuspensionModel.is180Days == undefined ? false : badDebtSuspensionModel.is180Days : false;

    this.createdUserId = badDebtSuspensionModel ? badDebtSuspensionModel.createdUserId == undefined ? '' : badDebtSuspensionModel.createdUserId : '';
  }
  divisionId?: string;
  // startDate?: string;
  // endDate?: string;
  branchId?: string;
  isCurrent?: boolean;
  is30Days?: boolean;
  is60Days?: boolean;
  is90Days?: boolean;
  is120Days?: boolean;
  is150Days?: boolean;
  is180Days?: boolean;
  createdUserId: string;
}


class BadDebtSuspensionApprovalDeclineModel {
  constructor(badDebtSuspensionApprovalDeclineModel?: BadDebtSuspensionApprovalDeclineModel) {
    this.declineReasonId = badDebtSuspensionApprovalDeclineModel ? badDebtSuspensionApprovalDeclineModel.declineReasonId == undefined ? '' : badDebtSuspensionApprovalDeclineModel.declineReasonId : '';
    this.approvedUserId = badDebtSuspensionApprovalDeclineModel ? badDebtSuspensionApprovalDeclineModel.approvedUserId == undefined ? '' : badDebtSuspensionApprovalDeclineModel.approvedUserId : '';
    this.referenceNo = badDebtSuspensionApprovalDeclineModel ? badDebtSuspensionApprovalDeclineModel.referenceNo == undefined ? '' : badDebtSuspensionApprovalDeclineModel.referenceNo : '';
    this.comments = badDebtSuspensionApprovalDeclineModel ? badDebtSuspensionApprovalDeclineModel.comments == undefined ? "" : badDebtSuspensionApprovalDeclineModel.comments : "";
    this.roleId = badDebtSuspensionApprovalDeclineModel ? badDebtSuspensionApprovalDeclineModel.roleId == undefined ? "" : badDebtSuspensionApprovalDeclineModel.roleId : "";
    this.fileName = badDebtSuspensionApprovalDeclineModel ? badDebtSuspensionApprovalDeclineModel.fileName == undefined ? "" : badDebtSuspensionApprovalDeclineModel.fileName : "";
  }
  declineReasonId?: string;
  approvedUserId?: string;
  referenceNo?: string;
  comments?: string;
  roleId?: string
  fileName?: string
}

export { BadDebtSuspensionModel, BadDebtSuspensionApprovalDeclineModel }

